// pages/auth/Login.jsx - Versión actualizada
import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useCart } from '../../context/CartContext'
import styles from './Login.module.css'

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [isAdminLogin, setIsAdminLogin] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  
  const navigate = useNavigate()
  const { login } = useAuth()
  const { fetchCartItems } = useCart() // Añadir esta línea

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    setError('') 
  }

  const handleCustomerAccess = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      if (!formData.email) {
        setError('Por favor ingresa tu email para continuar')
        return
      }

      // Para acceso como invitado, solo guardamos el email
      localStorage.setItem('guest_email', formData.email)
      localStorage.setItem('user_type', 'guest')
      
      // Actualizar el carrito después de guardar el email
      await fetchCartItems()
      
      navigate('/')
    } catch (err) {
      setError('Error al procesar el acceso')
      console.error('Guest access error:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleAdminLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      if (!formData.email || !formData.password) {
        setError('Por favor ingresa email y contraseña')
        return
      }

      const response = await login(formData.email, formData.password)
      
      // Verificar que sea admin
      if (response.profile?.role !== 'admin') {
        setError('No tienes permisos de administrador')
        return
      }

      // Redirigir al dashboard admin
      navigate('/admin/dashboard')
      
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión')
      console.error('Admin login error:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleRegisterRedirect = () => {
    navigate('/register')
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.loginHeader}>
          <h1>MiTienda</h1>
          <h2>{isAdminLogin ? 'Acceso Administrador' : 'Continuar como Invitado'}</h2>
          {error && (
            <div className={styles.errorMessage}>
              {error}
            </div>
          )}
        </div>

        <form 
          className={styles.loginForm} 
          onSubmit={isAdminLogin ? handleAdminLogin : handleCustomerAccess}
        >
          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="tu.email@ejemplo.com"
              className={error ? styles.inputError : ''}
              disabled={loading}
            />
          </div>

          {isAdminLogin && (
            <div className={styles.formGroup}>
              <label htmlFor="password">Contraseña</label>
              <input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                placeholder="Tu contraseña de administrador"
                className={error ? styles.inputError : ''}
                disabled={loading}
              />
              <Link to="/forgot-password" className={styles.forgotPassword}>
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
          )}

          <button 
            type="submit" 
            className={styles.loginButton}
            disabled={loading}
          >
            {loading ? (
              <div className={styles.loading}>
                <div className={styles.spinner}></div>
                {isAdminLogin ? 'Verificando...' : 'Accediendo...'}
              </div>
            ) : (
              isAdminLogin ? 'Ingresar como Admin' : 'Continuar como Invitado'
            )}
          </button>

          <div className={styles.loginOptions}>
            <button
              type="button"
              className={styles.switchButton}
              onClick={() => {
                setIsAdminLogin(!isAdminLogin)
                setError('')
                setFormData({ email: formData.email, password: '' })
              }}
              disabled={loading}
            >
              {isAdminLogin 
                ? '¿Eres cliente? Continuar como invitado' 
                : '¿Eres administrador? Acceder al panel'
              }
            </button>
            
            {!isAdminLogin && (
              <>
                <div className={styles.divider}>
                  <span>o</span>
                </div>
                
                <button
                  type="button"
                  className={styles.registerButton}
                  onClick={handleRegisterRedirect}
                  disabled={loading}
                >
                  Crear cuenta nueva
                </button>
              </>
            )}
          </div>
        </form>

        {/* Información adicional */}
        <div className={styles.loginFooter}>
          {isAdminLogin ? (
            <p className={styles.adminNote}>
              🔒 Área restringida para administradores
            </p>
          ) : (
            <div className={styles.guestInfo}>
              <h3>¿Por qué necesitamos tu email?</h3>
              <ul>
                <li>• Para procesar tu pedido</li>
                <li>• Enviarte confirmación de compra</li>
                <li>• Notificarte sobre el estado de tu envío</li>
              </ul>
              <p className={styles.privacy}>
                Tu privacidad es importante para nosotros. 
                <Link to="/privacy"> Ver política de privacidad</Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Login